import type {
  EditableCreateFieldOptions,
  PayItemsCreationValue,
} from '@cims-online/shared'
import PayItemSelect from 'components/CIMSSelect/common/PayItemSelect'
import type { CreationFieldProps } from '..'
import CreationFormItem from './CreationFormItem'

type PayItemsFieldOptions = Extract<
  EditableCreateFieldOptions,
  { type: 'pay_items' }
>

type PayItemsSelectProps = {
  field: PayItemsFieldOptions
  id?: string
  onBlur: () => void
  onChange?: (value: PayItemsCreationValue) => void
  value?: PayItemsCreationValue
}

/** Adapts scalar selection to the persisted pay-item array shape. */
function PayItemsSelect({
  field,
  id,
  onBlur,
  onChange,
  value = [],
}: PayItemsSelectProps) {
  return (
    <PayItemSelect
      allowClear={field.readOnly === null}
      disabled={field.readOnly !== null}
      id={id}
      mode={field.single ? undefined : 'multiple'}
      onBlur={onBlur}
      onChange={(selection) => {
        let optionIds: string[] = []
        if (typeof selection === 'string') optionIds = [selection]
        else if (Array.isArray(selection))
          optionIds = selection.filter(
            (optionId): optionId is string => typeof optionId === 'string'
          )
        onChange?.(optionIds)
      }}
      simple
      style={{ width: '100%' }}
      value={field.single ? value[0] : value}
    />
  )
}

type PayItemsCreationFieldProps = Omit<CreationFieldProps, 'field'> & {
  field: PayItemsFieldOptions
}

/** Renders a pay-item creation input with scalar or multiple selection. */
function PayItemsCreationField({
  error,
  field,
  onBlur,
}: PayItemsCreationFieldProps) {
  return (
    <CreationFormItem
      control={<PayItemsSelect field={field} onBlur={onBlur} />}
      error={error}
      field={field}
    />
  )
}

export default PayItemsCreationField
